module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/5x5_small-061b95d6429ff69c4c5264481c13b52e.png";